import React from 'react';
import Select from 'react-select';

import style from './TemplateSkeleton.module.css';

import API from 'Vulture/lib/API';

import {
	dropdownStyles,
} from './systemRules';

export default class VisualContentLoopPicker extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedOption: null,
		    options:        [],
		};
	}

	componentDidMount() {
		const {
			activeEntityKey,
			settingKey,
		} = this.props;

		const componentUUID = activeEntityKey.split('.')[1];
		const settingUUID = settingKey.split('.')[1];

		let existingSelectedID = 0;
		API.findMapRecord('component', componentUUID, 'setting', settingUUID)
			.then((mm) => {
				if (mm) {
					existingSelectedID = mm.int || 0;
				}

				return API.findRecords('visual_content_loop', {});
			})
			.catch((err) => {
				console.error('Error fetching component:', err);
				return API.findRecords('visual_content_loop', {});
			})
			.then((visualContentLoops) => {
				const options = visualContentLoops.map((vcl) => {
					return {
						id:    vcl.id,
						value: vcl.id,
						label: vcl.name,
					};
				});

				options.unshift({
					id:    0,
					value: 0,
					label: 'Unassigned',
				});

				const selectedOption = options.find((opt) => {
					return (opt.id === existingSelectedID);
				}) || null;

				this.setState({
					selectedOption,
					options,
				});
			})
			.catch((err) => {
				console.error('Error fetching visual content loops:', err);
			});
	}

	render() {
		const {
			updateSettingValue,
			pendingUpdate,
		} = this.props;

		const {
			selectedOption,
			options,
		} = this.state;

		let pendingSelectedOption = false;
		if (pendingUpdate !== undefined) {
			pendingSelectedOption = options.find((opt) => {
				return opt.value === pendingUpdate;
			});
		}

		return (
			<div className={style.settingContainer}>
				<div className={style.settingLabel}>
					Assign Visual Content Loop
				</div>
				<Select
					isMulti={false}
					closeMenuOnSelect={true}
					hideSelectedOptions={false}
					className={style.buttonsDropdown + ' ' + style.autoWidthSelect}
					styles={dropdownStyles}
					options={options}
					value={pendingSelectedOption || selectedOption}
					onChange={(selected) => {
						this.setState({
							selectedOption: selected,
						}, () => {
							updateSettingValue(selected.value);
						});
					}}
				/>
			</div>
		);
	}
}